import { render, staticRenderFns } from "./OkxeTabs.vue?vue&type=template&id=53ec942c"
import script from "./OkxeTabs.vue?vue&type=script&lang=js"
export * from "./OkxeTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports